import "../../style/components/glass.css";
export default function Glass({ children }) {
  return <div id="Glass">{children}</div>;
}
